import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
import LocationFooter from "./LocationFooter";
const CivilLaw = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Civil Law</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <p>
              Our civil law practice is dedicated to protecting the rights and
              interests of individuals and organizations in non-criminal
              disputes. From contractual disagreements and property disputes to
              tort claims and recovery suits, we provide end-to-end
              representation before courts and tribunals. Our approach
              emphasizes thorough research, precise drafting, and strategic
              litigation, ensuring our clients’ interests are safeguarded at
              every stage. Whether through mediation, arbitration, or full-scale
              litigation, we strive for practical and timely solutions that
              minimize risk while maximizing results.
            </p>
            <ul>
              <li>Property and land disputes.</li>
              <li>Consumer complaints.</li>
              <li>Contract enforcement.</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default CivilLaw;
